<template>
  <modal id="trial-offer-modal" centered size="lg" title-tag="h3" title="We're giving you Pro for 7 days for free!" :hide-header-close="true" :hide-footer="true" :no-close-on-backdrop="true">
    <p>No credit card needed. After your 7 days, you'll automatically be moved to a free plan.</p>
    <img id="gift" src="@img/gift.svg" alt="A gift for you"/>
    <div class="justify-content-center">
      <div class="d-inline-block">
        <ul class="text-left offer_features">
          <li class="item">Unlimited video recording</li>
          <li class="item">Custom branding</li>
          <li class="item">Custom buttons</li>
          <li class="item">Search and unlimited history</li>
          <li class="item">Privacy controls</li>
          <li class="item">Template presets</li>
          <li class="item">And more &hellip;</li>
        </ul>
      </div>
    </div>

    <img id="spinner" v-if="submitting" src="@img/spinner.svg"/>
    <button v-else type="button" @click="acceptOffer()" class="cloudapp-btn blue">Get Started</button><br>
    <span class="d-inline-block offer_decline mt-2" @click="declineOffer()">I don't want this offer</span>
  </modal>
</template>

<script>
import Modal from "@cmp/modal.vue";

export default {
  components: { Modal },
  props: {
    nodefaults: { type: Boolean, required: false, default: false }
  },
  data: function(){
    return {
      submitting: false
    }
  },
  methods: {
    declineOffer: function() {
      this.$emit("decline");
      if (!this.nodefaults) {
        this.$router.push({ name: 'downloads',  query: this.$route.query });
      }
    },
    acceptOffer: function(){
      const vm = this;
      vm.submitting = true;
      vm.$store.dispatch('createSubscription', { plan: "pro-with-trial-annual", immediate: true }).then(() => {
        vm.submitting = false;
        vm.$emit("accept");
        if (!vm.nodefaults) {
          vm.$router.push({ name: 'downloads', query: vm.$route.query});
        }
      }).catch(function(error) {
        const msg = error.response?.data?.errors[0]?.detail;
        vm.$root.toastError(`Could not start a trial: ${msg}`);
        console.warn(error.response);
        vm.$bvModal.hide("trial-offer-modal");
        vm.submitting = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  img#gift {
    width: 100px;
  }

  ul.offer_features {
    margin-top: 1rem;
    margin-bottom: 1rem;

    font-size: 12pt;
    font-weight: 400;
    list-style: none;

    li.item:before {
      content: "\002714\00a0";
    }
  }

  span.offer_decline {
    color: rgb(115, 130, 145);
    font-size: 10pt;
    cursor: pointer;
  }
</style>

<style lang="scss">
 /* bootstrap-vue parent elements are not really scoped, need to overwrite here */
  #trial-offer-modal {
    font-family: "Fira Sans", sans-serif;
    font-weight: 400;
    line-height: 18px;
    text-align: center;

    .modal-header {
      justify-content: center;
      border: 0;
    }
 }
</style>
